export default "__VITE_ASSET__CIuiwnOO__"